function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 48,
    viewBox: "0 0 86 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7662 5.49856C17.7662 5.16719 18.0349 4.89856 18.3662 4.89856H68.2164C68.5478 4.89856 68.8164 5.16719 68.8164 5.49856V41.8246H71.2935C71.6249 41.8246 71.8935 42.0933 71.8935 42.4246C71.8935 42.756 71.6249 43.0246 71.2935 43.0246H15.289C14.9577 43.0246 14.689 42.756 14.689 42.4246C14.689 42.0933 14.9577 41.8246 15.289 41.8246H17.7662V5.49856ZM67.6164 41.8246V6.09856H18.9662V41.8246H67.6164ZM20.8434 8.57576C20.8434 8.24439 21.112 7.97576 21.4434 7.97576H41.7527C42.0841 7.97576 42.3527 8.24439 42.3527 8.57576V39.3475C42.3527 39.6788 42.0841 39.9474 41.7527 39.9474H21.4434C21.112 39.9474 20.8434 39.6788 20.8434 39.3475V8.57576ZM22.0434 9.17576V38.7475H41.1527V9.17576H22.0434ZM44.2299 8.57576C44.2299 8.24439 44.4985 7.97576 44.8299 7.97576H65.1392C65.4706 7.97576 65.7392 8.24439 65.7392 8.57576V39.3475C65.7392 39.6788 65.4706 39.9474 65.1392 39.9474H44.8299C44.4985 39.9474 44.2299 39.6788 44.2299 39.3475V8.57576ZM45.4299 9.17576V38.7475H64.5392V9.17576H45.4299Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDouble);
export default __webpack_public_path__ + "static/media/Double.8ef377088a400fb76f257d93bc4290bb.svg";
export { ForwardRef as ReactComponent };